/**
 * @module  Experience/Browse-hardgoods
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/**
 * Enum values for credit levels
 */
export enum ProductTypeEnum {
  DEVICE,
  Accessory,
}

/**
 * Enum values for billing type
 */
export enum ProductSubTypeEnum {
  HANDSET,
  MOBILEINTERNET,
  SIMCARD,
}

/**
 * Constants for hardgoods
 */
export const HARDGOODS_CONSTANTS = {
  HTTP_URL: 'http(s?)://',
  ITEM_ADD: 'ADD',
  PRICERANGE: 'pricerange',
  PREPAID: 'PREPAID',
  DEVICE: 'DEVICE',
  ERROR: 'ERROR',
  REMOVE: 'REMOVE',
  ACCESSORY_COUNT: '3',
  POSTPAID: 'POSTPAID',
  CATEGORY: 'category',
  SUBCATEGORY: 'subcategory',
  PRODUCT_SELECTOR: '/product-selector',
  CART_REVIEW: '/cart/review',
  COMPARE_DEVICE: '/browse-phones/compare-devices',
  COMPARE_DEVICES: 'compare-devices',
  COMPARE_TABLETS: '/browse-tablets/compare-devices',
  BROWSE_DEVICES: '/browse-phones',
  BROWSE_DEVICES_URL: 'browse-phones',
  BROWSE_TABLETS: '/browse-tablets',
  BROWSE_ACCESSORIES: '/browse-accessories',
  BROWSE_ACCESSORIES_URL: 'browse-accessories',
  BROWSE_ACCESSORY_ACDP: '/browse-accessories/accessory-categoryDetails',
  BROWSE_ACCESSORY_ROUTE: 'browse-accessories/accessory-categoryDetails',
  BROWSE_ACCESSORY_CATEGORY: '/browse-accessories/accessoryCategory',
  BROWSE_ACCESSORY_CATEGORY_DETAILS: '/browse-accessories/accessoryCategory/categoryDetails',
  HOME: '/home',
  ACCOUNT_LANDING: '/account-landing',
  PRICE_HIGH_TO_LOW: 'Price high to low',
  ASCENDING: 'ascending',
  DESCENDING: 'descending',
  RELEVANCE: 'relevance',
  Z_TO_A: 'Z to A',
  BACKORDER: 'BACKORDER',
  COMPARE: '/compare-devices',
  PRODUCT_DETAILS: '/product-details',
  ALL: 'all',
  UPGARDE_DEVICES: '/upgrade-devices',
  DEVICE_FIRST: 'DEVICE_FIRST',
  SIMSTARTKIT: '$10',
  BROWSE_DEVICE_LANDING_COMPONENT: 'BrowseDevicesLandingComponent',
  TRUNCATE: '72',
  SKU_COLOR_IMAGE_PATH: 'sku_color_image_path',
  D_A1_LARGE: 'd_a1_large',
  D_AC_Fl_PN: 'd_ac_fl_pn',
  FRP_WITH_SERVICE: 'FRPWITHSERVICE',
  FRP: 'FRP',
  DEFAULT_AMOUNT: '0',
  BROWSE_PHONES: 'browse-phones',
  WEB: 'web',
  ASSESTEDCHANNELCLASS: '.gcui',
  UNASSESTEDCHANNELCLASS: '.custmr-actv-log',
  SALESCHANNELCODE_CARE: 'Over the Phone',
  SALESSUBCHANNELCODE_CARE: 'care',
  SIMCARD: 'SIMCARD',
  SUBCHANNELCATEGORY: 'Frontline',
  SALES_CHANNEL_CODE_RETAIL: 'In-Person',
  SALES_SUB_CHANNEL_CODE_RETAIL: 'Full Service',
  SUB_CHANNEL_CATEGORY_RETAIL: 'T-MobileRetail',
  SALES_CHANNEL_CODE_WEB: 'Unassisted',
  SALES_SUB_CHANNEL_CODE_WEB: 'Self Service Anonymous',
  SUB_CHANNEL_CATEGORY_WEB: 'General Anonymous',
  ACTIVATION: 'ACTIVATION',
  HARDGOOD: 'HardGood',
  BASE: 'Base',
  PAGESIZE: '24',
  ACCESSORYPRODUCTTYPE: 'Accessory',
  DEVICEPRODUCTTYPE: 'Device',
  DEVICEPRODUCTSUBTYPE: 'Handset',
  DEVICESIMKITPRODUCTSUBTYPE: 'SimCard',
  TABLETPRODUCTSUBTYPE: 'Tablet',
  WEARABLEPRODUCTSUBTYPE: 'Wearable',
  MOBILEINTERNETPRODUCTSUBTYPE: 'MobileInternet',
  HANDSET: 'HANDSET',
  TABLET: 'TABLET',
  MOBILEINTERNET: 'MOBILEINTERNET',
  BROWSE_TABLET: 'browse-tablets',
  VOUCHER: 'VOUCHER',
  FINANCIAL: 'financial',
  ACCESSORY: 'accessory',
  SKU_PRICE: 'skuPrice',
  E_PIN: 'E-PIN',
  OTHER_ACCESSORY: 'OtherAccessory',
  RETAIN: 'RETAIN',
  FULLPRICE: 'FullPrice',
  WITHOUT_SERVICE: 'WithoutService',
  TOURIST: 'tourist',
  IS_UPGRADE: 'isUpgrade',
  SEARCHENABLECOUNT: '10',
  AVAILABLE: 'AVAILABLE',
  CATEGORY_SELECTION_LIMIT: '3',
  CART_URL: '/cart',
  WRITE_REVIEW_URL: 'assets/bv.html',
  BAZAAR_WRITE_REVIEW_URL_KEY: 'bazaarvoiceWriteReviewUrl',
  LOADING_TEXT: 'Loading !!!',
  BACKORDERED: 'BACKORDERED',
  TOURIST_SIM_KIT: 'HOTMleTostSIMAconKit',
  BROWSE_PHONE_URL: '/browse-phones',
  BROWSE_TABLET_URL: '/browse-tablets',
  WITH_SERVICE: 'WithService',
  MANUFACTURER: 'manufacturer',
  TEST_DRIVE: 'so_test_app_30gb_v2',
  IS_TEST_DRIVE: 'isTestDrive',
  AVAILABILITY: 'availability',
  ESIM: 'ESIM',
  SHIP_TO: 'SHIPTO',
  CARTID: 'CARTID',
  VALIDATE_SIM: 'Validate SIM',
  FEATURES: 'features',
  PRODUCT_REVIEWS: 'product-reviews',
  INPROCESS_STATUS: 'INPROCESS',
};

export const HARDGOODS_INFINITE_SCROLL_CONSTANTS = {
  INFINITESCROLLDISTANCE: 1,
  INFINITESCROLLTHROTTLE: 100,
  PAGENUMBER: 1,
  SEARCH_LENGTH: 5,
};

export const DATE_FORMAT = {
  MMDDYYYY: 'MM/DD/YYYY',
};

export const AVAILABILITY = {
  AVAILABLE: 'AVAILABLE',
  LIMITEDAVAILABILITY: 'LIMITEDAVAILABILITY',
  BACKORDERED: 'BACKORDERED',
  IN_STOCK: 'IN STOCK',
  BACK_ORDER: 'BACK ORDER',
  NOT_AVAILABLE: 'NOT AVAILABLE',
  OUT_OF_STOCK: 'OUT OF STOCK',
};

export const DIGITALDATA_CONSTANT = {
  DIGITALDATA: 'digitalData',
  PAGE: 'page',
  PAGEINFO: 'pageInfo',
  SUBCATEGORY: 'subCategory',
  PRODUCT: 'product',
  PRODUCTINFO: 'productInfo',
  QTY: 'qty',
  PAGENAME: 'pageName',
  PRODUCT_COMPARE: 'Product Comparison',
};

export const PDP_SUBTYPE = {
  HANDSET: 'CELLPHONES',
  CELLPHONE: 'Cell Phone Detail',
  SIMCARD: 'SIM',
  SIMCARDDETAIL: 'SimCard Detail',
  MOBILEINTERNET: 'TABLETS',
  TABLET: 'Tablet & Device Detail',
  ACCESSORY: 'ACCESSORIES',
  ACCESSORYDETAIL: 'Accessory Detail',
};

export const PDP_TYPE = {
  ACCESSORY: 'Hardgood',
  DEVICE: 'Hardgood',
  FINANCIAL: 'Softgood',
};
